import NykForm from "./NykForm/NykForm.vue"

export default {
  name: "CustomForm",
  components: {
    NykForm
  },
  props: {
    formElements: {
      type: Array,
      required: true
    },
    showSummarizedData: {
      type: Boolean,
      default: false
    },
    summaryConfirmationButtonLabel: {
      type: String,
      default: "Bekræft og send"
    },
    summaryCancellationButtonLabel: {
      type: String,
      default: "Annuller"
    },
    confirmationMessage: {
      type: String
    },
    submitSuccessMessage: {
      type: String
    },
    submitErrorMessage: {
      type: String
    },
    resetAfterSubmission: {
      type: Boolean,
      default: true
    },
    formTitle: {
      type: String
    },
    formType: {
      type: String,
      default: 'not_set',
      validator: (value) => {
        const validTypes = [
          'not_set',
          'custom-form',
          'contact-advisor',
          'send-document-to-advisor'
        ];
        return validTypes.includes(value) || value === '';
      }
    },
    formId: {
      type: String,
      required: true
    },
    formGuid: {
      type: String,
      required: true
    },
    apiPath: {
      type: String,
      required: true
    },
    antiForgeryToken: {
      type: String,
      required: true
    }
  }
}
